module.exports = __webpack_public_path__ + "media/ets/25-e5836b78.png";